import axios from 'axios';

export async function fetchApi({ base= 'v1', url, filter = {}, options = {} }) {
    try {
        const result = await axios.get(`/${base}/${url}`, { params: { filter: filter && JSON.stringify(filter), ...options } });
        return result;
    } catch (err) {
        console.log(err.message)
    }    
}
